import { render, staticRenderFns } from "./OrticOauthButton.vue?vue&type=template&id=4180df22&"
import script from "./OrticOauthButton.vue?vue&type=script&lang=js&"
export * from "./OrticOauthButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports